<template>
  <b-container class="p-3" fluid>
    <b-row>
      <b-col>
        <b-card no-body>
          <h6 slot="header" class="mb-0">
            <font-awesome-icon icon="plus-circle" />สร้างหน่วยงานหรือสังกัด
          </h6>
          <table class="table mb-0">
            <tbody>
              <tr>
                <td>
                  <strong>ประเภท</strong>
                </td>
                <td class="align-middle">
                  <b-form-radio-group
                    id="radio-group-1"
                    v-model="form.type"
                    :options="options"
                  />
                </td>
              </tr>
              <tr v-if="parentApplicable">
                <td>
                  <strong>สังกัด</strong>
                </td>
                <td class="align-middle">
                  <b-select v-model="form.parentId" :options="parentOptions" />
                </td>
              </tr>
              <tr>
                <td>
                  <strong>ชื่อหน่วยงาน</strong>
                </td>
                <td class="align-middle">
                  <b-form-input v-model="form.name" />
                </td>
              </tr>
              <tr v-if="form.type !== 'Council' && form.type !== 'StudentUnion'">
                <td>
                  <strong>เปิดใช้งาน</strong>
                </td>
                <td class="align-middle">
                  <b-form-radio-group
                    id="radio-group-2"
                    v-model="form.isEnabled"
                    :options="isEnabledOptions"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </b-card>
        <b-card class="mt-3">
          <b-button variant="primary" @click="submit">
            <font-awesome-icon icon="save" /> บันทึก
          </b-button>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import gql from 'graphql-tag'
import groupFetchApplicableParentListQuery from '@/graphql/queries/fetchApplicableParentList.gql'

export default {
  data () {
    return {
      form: {
        name: '',
        parentId: null,
        type: 'Association',
        chiefName: '',
        advisorTel: '',
        isEnabled: true
      },
      options: [
        { text: 'สภานักศึกษา', value: 'Council' },
        { text: 'องค์การนักศึกษา', value: 'StudentUnion' },
        { text: 'สโมสรนักศึกษา', value: 'StudentCouncil' },
        { text: 'ชมรม', value: 'Club' },
        { text: 'ชุมนุม', value: 'Group' },
        { text: 'กลุ่ม', value: 'PeopleGroup' }
        // { text: 'สโมสร', value: 'Association' }
      ],
      isEnabledOptions: [
        { text: 'เปิด', value: true },
        { text: 'ปิด', value: false }
      ],
      parentOptions: []
    }
  },
  computed: {
    parentApplicable () {
      return this.form.type === 'StudentCouncil' || this.form.type === 'Group'
    },
    parentType () {
      if (this.form.type === 'StudentCouncil') { return 'StudentCouncil' }
      if (this.form.type === 'Group') { return 'Group' }
      return null
    }
  },
  watch: {
    parentType (type) {
      this.form.parentId = null
      if (type === null) { return }
      this.fetchParentList(type)
    }
  },
  methods: {
    async submit () {
      let group = await this.$apollo.mutate({
        mutation: gql`mutation ($input: GroupCreateInput) { groupCreate(input: $input) { id } }`,
        variables: { input: this.form }
      }).catch(() => {
        this.$bvToast.toast('เกิดข้อผิดพลาดในการบันทึกข้อมูล ตรวจสอบการกรอกข้อมูลอีกครั้ง', {
          title: 'แจ้งเตือน',
          variant: 'danger',
          solid: true
        })
      })
      this.$router.push({ name: 'settings.groups.show', params: { id: group.data.groupCreate.id } })
    },
    async fetchParentList (type) {
      const result = await this.$apollo.query({
        query: groupFetchApplicableParentListQuery,
        variables: { type }
      })

      this.parentOptions = result.data.groupFetchApplicableParentList
    }
  }
}
</script>

<style scoped lang="scss">
td {

  &:first-child {
    background-color: #f2f2f2;
    width: 250px;
    p {
      margin-bottom: 0;
      font-size: $font-size-sm * 0.9;
      color: $gray-600;
    }
  }
}
</style>
